export default "__VITE_ASSET__DE7CrGdI__"